module.exports = __webpack_public_path__ + "img/2.30a8ccd9.png";